<template>
  <div>
    <div :class="{ 'aside': true, 'mobile': menuShow }">
      <el-menu id="menu" :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item :index="item.path" v-for="(item, index) in menu" :key="index">
          <router-link :to="{ path: item.path }" tag="p" class="link">
            <i :class="[item.class, 'icon']"></i>
            <span>{{ item.title }}</span>
          </router-link>
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
import bus from "@/utils/bus.js";
export default {
  data() {
    return {
      menu: [
        {
          title: "Recharge",
          class: "el-icon-coin",
          path: "recharge",
        },
        {
          title: "Official recharge",
          class: "el-icon-notebook-2",
          path: "officialrecharge",
        },

        {
          title: "Record",
          class: "el-icon-notebook-2",
          path: "record",
        },
        {
          title: "Host Statistic",
          class: "el-icon-s-order",
          path: "statistic",
        },
        {
          title: "Host Daily Rank",
          class: "el-icon-data-analysis",
          path: "dailyrank",
        },
        {
          title: "Auto-Top-Up",
          class: "el-icon-notebook-2",
          path: "auto-top-up",
        },
      ],
      menuShow: true,
    };
  },

  created() {
    let authority = JSON.parse(localStorage.getItem("authority"));
    let newAuthority = [];
    this.menu.forEach((value, index) => {
      let status = authority.findIndex((item, ind) => {
        if (this.$route.name == item) {
          this.classindex = ind;
        }
        return value.path === item;
      });
      if (status >= 0) {
        // this.$set(this.classArr[index], "status", false);
        newAuthority.push(this.menu[index]);
      }
    });
    this.menu = newAuthority;
  },
  methods: {
    handleSelect(index) {
      //   this.menuShow = true;
      // localStorage.setItem("routerIndex", index);
    },
  },
  computed: {
    activeIndex() {
      let authority = JSON.parse(localStorage.getItem("authority"));
      let routename = this.$route.name
      if (authority.indexOf(routename) != -1) return routename
      return authority.length && authority[0];
    },
  },
  mounted() {
    bus.$on("mobileShow", () => {
      return (this.menuShow = false);
    });
    document.onclick = (e) => {
      if (
        !(
          e.target.getAttribute("class") &&
          e.target.getAttribute("class").indexOf("header-icon") > -1
        )
      ) {
        this.menuShow = true;
      }
    };
  },
};
</script>

<style lang="scss" scoped>
.aside {
  background: #fff;
  position: fixed;
  top: 80px;
  left: 0;
  width: 100%;
  //   height: 50px;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  z-index: 1;

  #menu {
    box-sizing: border-box;
    padding: 0 30px;
    color: #75b9a8;

    .el-menu-demo {
      display: block;
    }

    .el-menu-item {
      margin: 0 20px;
      padding: 0;
    }

    .link {
      width: 100%;
    }

    &>.is-active {
      border-bottom: 2px solid #75b9a8;
    }
  }
}

@function rem($size, $rem: 37.5) {
  @return $size / $rem +rem;
}

@media screen and (max-width: 680px) {
  .aside {
    top: 80px;
    left: 0;
    width: 100%;
    // height: 50px;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    z-index: 99;

    &.mobile {
      display: none;
    }

    #aa {
      box-sizing: border-box;
      padding: 0 rem(20);
      color: #75b9a8;
      display: flex;
      flex-direction: column;

      .el-menu-item {
        display: block;
      }

      &>.is-active {
        border-bottom: 2px solid #75b9a8;
      }
    }
  }
}</style>


// WEBPACK FOOTER //
// src/components/modules/aside.vue